import { Injectable, inject } from '@angular/core';
import { fetchCurrentTimezone } from '@lessor/core/store/timezone/timezone-info.actions';
import { selectSportCenterTimezone } from '@lessor/core/store/timezone/timezone-info.seletors';
import { SportCenterTimezoneProvider } from '@libs/util-services';
import { Store } from '@ngrx/store';

/**
 * Implementação concreta do SPORT_CENTER_TIMEZONE_PROVIDER. Lê o timezone
 * do centro esportivo do store do lessor pra alimentar o marcador "agora"
 * (linha vermelha estilo Google Calendar) na agenda.
 *
 * Quando o store ainda não carregou o timezone (ou centro sem timezone
 * configurado), retorna null e o grid cai no timezone local do browser.
 */
@Injectable({ providedIn: 'root' })
export class LessorSportCenterTimezoneProvider implements SportCenterTimezoneProvider {
  private readonly store = inject(Store);
  private readonly timezoneSignal = this.store.selectSignal(selectSportCenterTimezone);

  constructor() {
    // Auto-carrega no primeiro uso (singleton root → roda 1x por sessão).
    // A única outra origem do fetch é a página de configuração de fuso, que
    // quase nenhuma sessão visita — sem isso o store fica vazio e o marcador
    // "agora" cai no fuso do browser (errado pra dono viajando).
    if (!this.timezoneSignal()?.trim()) {
      this.store.dispatch(fetchCurrentTimezone());
    }
  }

  getTimezone(): string | null {
    return this.timezoneSignal()?.trim() || null;
  }
}
